import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, TrendingUp, ShoppingBag, Users, Calendar } from 'lucide-react';
import { QuoteButton } from './QuoteModal';

/**
 * Dark "Ready to Rank #1 on Google & ChatGPT?" CTA module.
 * Lives above the footer on every page.
 */
const ReadyToRankCTA = () => {
  return (
    <section
      className="relative bg-[#05070c] py-20 md:py-28 overflow-hidden"
      data-testid="ready-to-rank-cta"
    >
      {/* Soft ambient glows */}
      <div className="pointer-events-none absolute -top-20 left-1/4 h-96 w-96 rounded-full bg-[#22c55e]/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-1/4 h-96 w-96 rounded-full bg-[#f97316]/10 blur-3xl" />

      <div className="container relative mx-auto px-4 md:px-6">
        {/* Glowing border card */}
        <div className="relative max-w-4xl mx-auto">
          {/* Gradient glow outline */}
          <div className="absolute -inset-[2px] rounded-[2rem] bg-gradient-to-br from-[#22c55e] via-[#0f172a] to-[#f97316] opacity-70 blur-[2px]" />

          <div className="relative rounded-[2rem] bg-[#0b1220] px-6 py-12 md:px-14 md:py-16 border border-slate-800/70">
            {/* Icon badge */}
            <div className="flex justify-center mb-8">
              <div className="relative">
                <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-[#22c55e] to-[#f97316] blur-xl opacity-60" />
                <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-[#15803d] to-[#f97316] flex items-center justify-center shadow-lg">
                  <TrendingUp size={26} className="text-white" strokeWidth={2.5} />
                </div>
              </div>
            </div>

            <h2 className="font-['Outfit'] text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight text-center leading-[1.05] mb-5">
              Ready to Rank #1 on<br />Google &amp; ChatGPT?
            </h2>

            {/* Gradient divider */}
            <div className="flex justify-center mb-8">
              <div className="h-1 w-28 rounded-full bg-gradient-to-r from-[#22c55e] via-[#eab308] to-[#f97316]" />
            </div>

            <p className="text-center text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto mb-10">
              Join 1000+ successful businesses. Get <strong className="text-white">SEO + AI Optimisation</strong> with proven results. No lock-in contracts, no exit fees.
            </p>

            {/* Stat chips */}
            <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
              <span className="inline-flex items-center gap-2 rounded-full border border-[#22c55e]/40 bg-[#22c55e]/5 text-white px-4 py-2 text-xs md:text-sm font-semibold">
                <ShoppingBag size={14} className="text-[#22c55e]" /> Rank on Google &amp; AI Search
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-[#1d4ed8] text-white px-4 py-2 text-xs md:text-sm font-semibold">
                <Users size={14} /> 45+ SEO Experts
              </span>
              <span className="inline-flex items-center gap-2 rounded-full border border-slate-700 text-white px-4 py-2 text-xs md:text-sm font-semibold">
                <Calendar size={14} className="text-slate-400" /> Since 2016
              </span>
            </div>

            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row items-stretch justify-center gap-3 md:gap-4 mb-10">
              <QuoteButton
                data-testid="ready-to-rank-quote-btn"
                className="group inline-flex items-center justify-center gap-2 rounded-xl bg-[#f97316] hover:bg-[#ea580c] text-white px-8 py-4 font-bold text-base shadow-lg shadow-[#f97316]/30 transition-all hover:-translate-y-0.5"
              >
                Get My Free Quote
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </QuoteButton>
              <Link
                to="/#case-studies"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-slate-800 hover:bg-slate-700 border border-slate-700 text-white px-8 py-4 font-bold text-base transition-all"
              >
                View Success Stories
              </Link>
            </div>

            {/* Call now card */}
            <div className="flex justify-center">
              <a
                href="tel:1800006296"
                className="group inline-flex items-center gap-4 rounded-2xl bg-slate-900/70 border border-slate-800 hover:border-slate-700 px-5 py-3 transition-all"
              >
                <div className="w-11 h-11 rounded-xl bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center transition-colors">
                  <Phone size={18} className="text-white" />
                </div>
                <div className="text-left">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-slate-400 font-semibold">Call Us Now</p>
                  <p className="text-lg md:text-xl font-bold text-white">1800 006 296</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyToRankCTA;
